export default __webpack_public_path__ + "assets/img/loader.2f4e6b157916ad99d32868b39b5db281.gif";